var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{attrs:{"placement":_vm.placement,"transfer":"","placeholder":_vm.placeholder,"type":"date","format":"d/MM/yyyy"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }